import { render } from "./PasswordForgotten.vue?vue&type=template&id=163ac4ea&scoped=true"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js"

import "./PasswordForgotten.vue?vue&type=style&index=0&id=163ac4ea&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163ac4ea"]])

export default __exports__